import { render } from "./allocating.vue?vue&type=template&id=489bd87e&scoped=true"
import script from "./allocating.vue?vue&type=script&lang=js"
export * from "./allocating.vue?vue&type=script&lang=js"

import "./allocating.vue?vue&type=style&index=0&id=489bd87e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489bd87e"]])

export default __exports__